export default __webpack_public_path__ + "static/fail2ban-0f66e141ef61d0343402ae6429c264ee.png";